import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";
import VideoFeaturePanel from "../../../../components/VideoFeaturePanel/VideoFeaturePanel";
import Benefits from "../../../../components/Benefits/Benefits";
import Testimonials from "../../../../components/Testimonials/Testimonials";
import RelatedServices from "../../../../components/RelatedServices/RelatedServices";
import AdditionalServicesLayout from "../../../../components/AdditionalServicesLayout";
const ClientExperience = ({ location }) => {
  const {
    data,
    data: {
      benefits: benefitsData,
      testimonials: testimonialsData,
      services: relatedServicesData,
      Articles: articlesData,
      topics,
      client_types,
      filter_types,
    },
  } = useStaticQuery(
    graphql`
      {
        data: strapiSolutionsAdditionalServicesClientExperience {
          topics {
            id
            type
          }
          client_types {
            id
            Type
          }
          filter_types {
            type
          }
          Articles {
            articlesHeading
            insights {
              id
            }
            case_studies {
              id
            }
            press_releases {
              id
            }
            events {
              id
            }
          }
          services {
            shortDesc
            Image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    webpOptions: { quality: 100 }
                    placeholder: TRACED_SVG
                  )
                }
              }
              alternativeText
            }
          }
          benefits {
            Copy
            Title
            Icon {
              localFile {
                publicURL
              }
            }
          }

          metaData {
            pageTitle
            metadescription
          }
          faqLink {
            faq_category {
              category
            }
            text
          }
          testimonials {
            ColorTheme
            Pattern {
              localFile {
                publicURL
              }
            }
            testimonials {
              Name
              Role
              Copy
              Logo {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 200
                      quality: 100
                      webpOptions: { quality: 100 }
                    )
                  }
                }
                alternativeText
              }
            }
          }
          featurePanel {
            copy
            heading
            headerImage {
              localFile {
                publicURL
              }
            }
            video {
              video {
                localFile {
                  publicURL
                }
              }
              transcript {
                localFile {
                  id
                  publicURL
                }
              }
            }
            mainImage {
              alternativeText
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
        }
      }
    `
  );

  return (
    <AdditionalServicesLayout
      currentPath={location.pathname}
      metaData={data.metaData}
    >
      <VideoFeaturePanel data={data.featurePanel} />
      <Benefits benefitsData={benefitsData} faqLink={data.faqLink} />
      <Testimonials testimonialsData={testimonialsData} />
      <RelatedServices
        relatedServicesData={relatedServicesData}
        articlesData={articlesData}
        tagTypes={filter_types}
        topics={topics}
        client_types={client_types}
      />
    </AdditionalServicesLayout>
  );
};
export default ClientExperience;
